$(document).on('turbolinks:load', function() {
  // プレイヤー詳細ページのトグルボタン処理
  // プレイヤー詳細ページ以外では実行しない
  if (!window.Janreco.currentPath().match(/^\/players\/\d+$/)) {
    return;
  }

  const $toggleBtn = $('#play-type-toggle-switch');
  const $result4 = $('#result-4');
  const $result3 = $('#result-3');
  const $mainResults4 = $('#main-results-4');
  const $mainResults3 = $('#main-results-3');
  
  if ($toggleBtn.length === 0) {
    return;
  }

  // URLパラメータから初期状態を取得
  let params = new URLSearchParams(window.location.search);
  let playType = params.get('play_type');
  // URLパラメータがない場合はサーバーから渡されたデフォルト値を使用
  let currentType = playType ? parseInt(playType) : ($toggleBtn.data('default-type') || 4);

  // 関数定義
  function updateSwitchState(type) {
    const $fourOption = $toggleBtn.find('[data-type="4"]');
    const $threeOption = $toggleBtn.find('[data-type="3"]');
    
    // 全ての状態をリセット
    $fourOption.removeClass('active');
    $threeOption.removeClass('active');
    $toggleBtn.removeClass('three-active');
    
    const $pageTitle = $('.page-title h1');
    if (type === 4) {
      $fourOption.addClass('active');
      $pageTitle.text($toggleBtn.data('heading-four'));
    } else {
      $threeOption.addClass('active');
      $toggleBtn.addClass('three-active');
      $pageTitle.text($toggleBtn.data('heading-three'));
    }
  }

  function updateResults(type) {
    if (type === 4) {
      $result4.show();
      $result3.hide();
      $mainResults4.show();
      $mainResults3.hide();
      // 四人麻雀のグラフを再描画
      if (typeof window.redrawDoughnutChart4 === 'function') {
        window.redrawDoughnutChart4();
      }
      if (typeof window.redrawTotalPointChart4 === 'function') {
        window.redrawTotalPointChart4();
      }
      if (typeof window.redrawWindRadarChart4 === 'function') {
        window.redrawWindRadarChart4();
      }
      if (typeof window.redrawOpponentChart4 === 'function') {
        window.redrawOpponentChart4();
      }
    } else {
      $result3.show();
      $result4.hide();
      $mainResults3.show();
      $mainResults4.hide();
      // 三人麻雀のグラフを再描画
      if (typeof window.redrawDoughnutChart3 === 'function') {
        window.redrawDoughnutChart3();
      }
      if (typeof window.redrawTotalPointChart3 === 'function') {
        window.redrawTotalPointChart3();
      }
      if (typeof window.redrawWindRadarChart3 === 'function') {
        window.redrawWindRadarChart3();
      }
      if (typeof window.redrawOpponentChart3 === 'function') {
        window.redrawOpponentChart3();
      }
    }
  }

  // スイッチ風ボタンの設定
  const $switchOptions = $toggleBtn.find('.switch-option');
  
  $switchOptions.each(function(index, element) {
    const $option = $(element);
    const optionType = $option.data('type');
    
    $option.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const newType = parseInt(optionType);
      
      if (newType !== currentType) {
        currentType = newType;
        updateSwitchState(currentType);
        updateResults(currentType);
        
        // URLを更新（ページリロードなし）
        const newUrl = new URL(window.location);
        newUrl.searchParams.set('play_type', currentType);
        window.history.pushState({}, '', newUrl);
        // 期間フィルターで再読み込みしても選択中の四麻/三麻を保つ
        $('#stats-year-form input[name="play_type"]').val(currentType);
      }
    });
  });
  
  // 初期状態を設定
  updateSwitchState(currentType);
  updateResults(currentType);
});
